/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui";
import { DownloadCloud } from "lucide-react";

export default function DownloadTemplate() {
  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;
  let excelExport3: ExcelExport | null;

  const onDownloadTemplate = (type: string) => {
    if (type === "Single Currency") {
      excelExport1?.save([]);
    } else if (type === "Foreign Currency") {
      excelExport3?.save([]);
    } else if (type === "AED Coins") {
      excelExport2?.save([]);
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="gap-2">
            <DownloadCloud /> Download Templates
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[180px]">
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("Single Currency");
            }}
            className="cursor-pointer"
          >
            Single Currency
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("AED Coins");
            }}
            className="cursor-pointer"
          >
            AED Coins
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("Foreign Currency");
            }}
            className="cursor-pointer"
          >
            Foreign Currency
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ExcelExport
        ref={(exporter) => {
          excelExport1 = exporter;
        }}
        fileName={`B2B_Single_Currency_Bags_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "containerType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "value", title: "Value" },
          { field: "chequePieces", title: "Cheque Pieces" },
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport2 = exporter;
        }}
        fileName={`B2B_Coins_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "containerType", title: "Bag Type" },
          { field: "denominations", title: "Denomination" },
          { field: "count", title: "Count" },
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport3 = exporter;
        }}
        fileName={`B2B_FC_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "containerType", title: "Bag Type" },
        ]}
      />
    </>
  );
}
